import axios from 'axios';
import { STORE_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const getStoreOrderDashboard = (storeId) => {
  return axios({
    method: 'get',
    url: STORE_BASE_URL + '/store/api/secure/v2/store/' + storeId + '/store-order-dashboard',
    headers: getHeaders(),
  });
};

export const getStoreOrderDashboardNew = (storeId) => {
  return axios({
    method: "get",
    url:
      STORE_BASE_URL +
      "/store/api/secure/v4/store/" +
      storeId +
      "/store-order-dashboard",
    headers: getHeaders(),
  });
};

export const storeOrders = (storeId, data) => {
  return axios({
    method: "post",
    url:
      STORE_BASE_URL +
      "/store/api/secure/v1/store/" +
      storeId +
      "/store-order-by-status",
    // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const getStoreOrderDashboardAdmin = (brandId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/brand/' +
      brandId +
      '/store-order-dashboard',
    // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getStoreOrderDashboardAdminNew = (brandId, data) => {
  return axios({
    method: "post",
    url:
      STORE_BASE_URL +
      "/store/api/secure/v3/brand/" +
      brandId +
      "/store-order-dashboard",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getStoreOrderSource = (brandId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/analytic/brand/' +
      brandId +
      '/store-order-source',
    // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const getStoreOrderByMonth = (brandId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/analytic/brand/' +
      brandId +
      '/store-order-by-month',
    // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getAnalyticsStoreOrderByStatus = (brandId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/analytic/brand/' +
      brandId +
      '/store-order-by-status',
    // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const getStoreNewPick = (storeId) => {
  return axios({
    method: "get",
    url:
      STORE_BASE_URL +
      "/store/api/secure/v1/store-new-pick/" +
      storeId,
    headers: getHeaders(),
  });
};